// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"419":"c2d6a1fc","563":"43a5dccd","778":"a5388f92","787":"5592bf64","942":"2f2008b4"}[chunkId] + ".chunk.js";
};